import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { Collapse } from 'react-collapse';

const policyLinks = [
  { label: 'Terms of use', to: '/terms' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Safety Overview', to: '/safety-overview' },
  { label: 'Data Removal Policy', to: '/data-removal-policy' },
];

const sectionLinks = [
  { label: 'Features', hash: '#features' },
  { label: 'AI Coach', hash: '#coach' },
  { label: 'How it works', hash: '#howitworks' },
];

const getSectionHref = (pathname, hash) => (pathname === '/' ? hash : `/${hash}`);

const PricingSoonLink = ({ onClick }) => (
  <Link className="bl-header-pricing-link" to="/pricing" onClick={onClick}>
    <span>Pricing</span>
    <span className="bl-header-pricing-link__badge">Soon</span>
  </Link>
);

function MenuMobile({ handleCloseMenu }) {
  const { pathname } = useLocation();
  const [isPoliciesOpen, setIsPoliciesOpen] = useState(false);
  const isPolicyActive = policyLinks.some((link) => link.to === pathname);

  return (
    <ul className="navigation bl-header-mobile-nav">
      {sectionLinks.map((link) => (
        <li key={link.hash}>
          <a href={getSectionHref(pathname, link.hash)} onClick={handleCloseMenu}>{link.label}</a>
        </li>
      ))}
      <li className={pathname === '/pricing' ? 'active' : ''}>
        <PricingSoonLink onClick={handleCloseMenu} />
      </li>
      <li className={`${isPolicyActive ? 'active' : ''} menu-item-has-children`}>
        <h5 onClick={() => setIsPoliciesOpen((current) => !current)}>
          Terms & Policies <i className="fas fa-angle-down" aria-hidden="true" />
        </h5>
        <Collapse isOpened={isPoliciesOpen}>
          <ul className="sub-menu" style={{ display: isPoliciesOpen ? 'block' : 'none' }}>
            {policyLinks.map((link) => (
              <li className={`${pathname === link.to ? 'active' : ''} menusub-link`} key={link.to}>
                <Link to={link.to} onClick={handleCloseMenu}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </Collapse>
        <div className="dropdown-btn" onClick={() => setIsPoliciesOpen((current) => !current)}>
          <span className="fas fa-angle-down" />
        </div>
      </li>
    </ul>
  );
}

export default MenuMobile;
